import { defineStore } from 'pinia';

export const requestsExtractStore = defineStore('requests', {
  state: () => {
    return {
      requestId: '',
      response: {} as any,
      extracts: [],
      cloneOldTextAreaValue: '',
      cloneOldTextAreaValueRefusal: '',
    };
  },

  actions: {
    setResponse(res: any) {
      this.response = res;
      this.requestId = res?.object?.dimensions?.dim_order_id;

      const found_extracts = res.found_extracts.map((val, key) => {
        val.id = key + 1;
        return val;
      });

      this.sendExtract(found_extracts);
    },
    sendExtract(data: any) {
      this.extracts = data;
    },
    setExtract(data: object) {
      Object.assign(this.extracts, data);
    },
    deleteExtract(id: number | string) {
      this.extracts = this.extracts.filter(
        (val: { id: number }) => val.id !== id
      );
    },
  },

  getters: {
    getExtracts: state => state.extracts,
  },
});

interface infoExtracts {
  id: string | number;
  personal_account: string;
  name_applicant: string;
  date: string | number;
  address: string;
  number: string | number;
  executor: string;
  formation_date: string | number;
  type: string | number;
  digital_signature: '';
}
